module.exports = __webpack_public_path__ + "img/header.a072c01a.png";